<template>
  <div class="investor-fee-config">
    <div v-if="loading" class="loading-container">
      <a-spin size="large" />
    </div>
    <template v-else-if="feeConfigList && feeConfigList.length > 0">
      <div class="fee-config-row" v-for="item in feeConfigList" :key="item.id">
        <div class="fee-config-item">
          <span class="label">{{ $t('applicableObject') }}:</span>
          <span class="value">{{ formatUserType(item.userType) }}</span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('feeName') }}:</span>
          <span class="value">{{ item.title }}</span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('chargeNode') }}:</span>
          <span class="value"><Dict :dict-code="DICT_CODE.FEE_AMOUNT_DETAIL_JUNCTURE" :value="item.juncture" /></span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('chargeStandard') }}:</span>
          <span class="value">
            <Dict :dict-code="DICT_CODE.AMOUNT_TYPE" :value="item.amountType" />
            {{ item.amountType === 1 ? item.fixedFee : (item.percentFee || 0) * 100 + '%' }}
          </span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('effectiveTime') }}:</span>
          <span class="value">{{ formatDateDisplay(item.startDate) }}</span>
        </div>
      </div>
    </template>
    <div v-else class="empty-container">
      <a-empty description="null" />
    </div>
  </div>
</template>

<script>
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'
import { getFeeConfig } from '@/webpublicapi/vietnamBackstage'

export default {
  name: 'InvestorFeeConfiguration',
  components: { Dict },
  data() {
    return {
      DICT_CODE,
      loading: false,
      feeConfigList: [],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getFeeConfig()
        if (res && res.respData && res.respData.records && res.respData.records.length > 0) {
          this.feeConfigList = res.respData.records
        }
      } catch (error) {
        this.$message.error(this.$t('investorList.sb'))
      } finally {
        this.loading = false
      }
    },
    formatDateDisplay(dateStr) {
      if (!dateStr) return '-'
      // Convert ISO 8601 format (e.g. 2026-05-29T17:00:00.000+00:00) to DD/MM/YYYY HH:mm:ss
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },
    formatUserType(userType) {
      if (userType === 1) return this.$t('platformCollection.fee_details_individual')
      if (userType === 10) return this.$t('platformCollection.fee_details_enterprise')
      return this.$t('individualAndEnterprise')
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.investor-fee-config {

  .loading-container,
  .empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
  }

  .fee-config-row {
    background-color: #bde9c1;
    padding: 16px;
    border-radius: 4px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;

    & + .fee-config-row {
      margin-top: 16px;
    }

    .fee-config-item {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .label {
        font-size: 14px;
        color: #333;
        flex-shrink: 0;
        min-width: 80px;
        text-align: right;
      }

      .value {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>
